import { CartHandoffScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <CartHandoffScreen />;
}
